<template>
	<div>
		<div id="login"></div>
	</div>
</template>

<style scoped>

</style>

<script>
	import store from '../store'
	import axios from 'axios'
	import VueAxios from 'vue-axios'
	import router from '../router'
	import { mixin } from '../components/mixins/mixin'

	export default {
		name: 'LogIn',

		mixins: [mixin],

		created: function(){
			let urlParams = window.location.search;

			if(!urlParams.length && !store.state.authToken.length) {
				router.push('/')
			} else {
				const vc = this;
				axios.get(process.env.VUE_APP_AUTH_URL+'/verify'+urlParams+'&redirect_uri='+process.env.VUE_APP_REDIRECT_URI)
				.then( function(response){
					//console.log(response)
					store.commit('setAuthToken', response.data.access_token)
					store.commit('setRefreshToken', response.data.refresh_token)

					$('#app').addClass('open')

					if(['ValidateConfig','PublicConfigParams'].includes(sessionStorage.latestComponent)) {

						$('#loader').fadeIn().addClass('show')

						const config = JSON.parse(sessionStorage.tmpConfig)

						axios
						.get(process.env.VUE_APP_API_URL+'/configs', {
							headers: {
								'Authorization': 'Bearer '+store.state.authToken
							}
						})
						.then( function(response){
							store.commit('setConfigs', response.data.configs);

							var count = response.data.configs.length+1;
							axios
							.post(process.env.VUE_APP_API_URL+'/configs', {
									name: (sessionStorage.latestComponent == 'ValidateConfig') ? config.name+' '+count : config.name,
									pgVersion: config.pgVersion
								},
								{
									headers: {
										'Authorization': 'Bearer '+store.state.authToken
									}
								}
							)
							.then( function(response){ // Add postgresql.conf file
								const configId = response.data.configId;

								axios
								.put(process.env.VUE_APP_API_URL+'/configs/'+configId+'/postgresql.conf', {
									headers: {
										'Authorization': 'Bearer '+store.state.authToken,
										'accept': '*/*',
										'Content-Type': 'application/x-www-form-urlencoded'
									}
								})
								.then( function(response){ // Adding config params to file
									axios
									.patch(process.env.VUE_APP_API_URL+'/configs/'+configId+'/postgresql.conf', {params: config.params}, {
										headers: {
											'Authorization': 'Bearer '+store.state.authToken
										}
									})
									.then( function(response){
										router.push('/manage/config/'+configId)

										if(['ValidateConfig', 'ConfManage'].includes(sessionStorage.latestComponent))
											vc.notify('<p>Configuration created successfuly.</p>')
										else
											vc.notify('<p>Configuration cloned successfuly.</p>')

									}).catch(function(err) {
										console.log(err);
									});
								}).catch(function(err) {
									console.log(err);
								});

							}).catch(function(err) {
								console.log(err);
							});
						}).catch(function(err) {
							console.log(err);
						});
					} else {
						router.push('/manage')
					}

					vc.fetchConfigs(true)

				}).catch(function(err) {
					console.log(err);
				});
			}
		}
	}


</script>
